import { Box, Divider } from '@mui/material';

import { EmpPosition } from '~/data/employee';

import { OverlappingEmploymentFormValues } from '../../hooks/useOverlappingEmploymentForm';

import { AllowanceForm } from './components/AllowanceForm';
import { BenefitForm } from './components/BenefitForm';
import { StartingSalaryForm } from './components/StartingSalaryForm';
import { useSxStyles } from './components/useStyles';
import { WorkingHoursForm } from './components/WorkingHoursForm';

interface Props {
  empId: number;
  empPosition: EmpPosition;
  formValues: OverlappingEmploymentFormValues;
}

export const RewardingDataTabForm = ({
  empId,
  empPosition,
  formValues,
}: Props) => {
  const sxStyles = useSxStyles();

  return (
    <Box sx={sxStyles.bottomClear}>
      <StartingSalaryForm formValues={formValues} />
      <Divider sx={sxStyles.divider} />
      <WorkingHoursForm
        empId={empId}
        empPosition={empPosition}
        formValues={formValues}
      />
      <Divider sx={sxStyles.divider} />
      <BenefitForm
        empId={empId}
        empPosition={empPosition}
        formValues={formValues}
      />
      <Divider sx={sxStyles.divider} />
      <AllowanceForm
        empId={empId}
        empPosition={empPosition}
        formValues={formValues}
      />
    </Box>
  );
};
